import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import PdfDocument from "./Components/generateInvoice/Invoice";
import InvoiceData from "./jsonData/InvoiceData";
import { Image } from "@react-pdf/renderer";
import download from "./assets/download.png";
import { BASE_URL } from "../../../baseurl";
import { useEffect, useState } from "react";
import axios from "axios";

const Tables = () => {
  const fileName = "POSP_Certificate.pdf";

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const styles = {
    download: {
      position: "fixed",
      top: "15%",
      left: "68%",
      zIndex: 100,
    },
    pdf: {
      margin: "auto",
      overflow: "hidden",
      height: "100%",
      width: "100%",
      border: 0,
    },
  };

  const getCertificateData = async () => {
    try {
      let token = localStorage.getItem("user_token");
      let res = await axios.get(`${BASE_URL}/user/data/getDetails`, {
        headers: {
          Authorization: token,
        },
      });
      let data = res.data;
      // console.log(data);

      setLoading(false);
      // console.log(data?.data?.uniquePartnerID, "1checkdata--->>>");
      if (res.status == 200) {
        localStorage.setItem("date", data?.data?.certificateUpdateDate);
        localStorage.setItem("uniquePartnerID", data?.data?.uniquePartnerID);
        setData(res?.data?.data);
      }
    } catch (e) {
      setLoading(false);
      console.error(e);
    }
  };

  useEffect(() => {
    getCertificateData();
  }, []);

  return (
    <div className="relative flex justify-center h-[800px] ">
      {!loading ? (
        data?.certificateStatus === "approved" ? (
          <div className="m-auto mt-5 h-[800px] w-[40%] ml-[750px]">
            <PDFViewer
              width={800}
              height={1000}
              showToolbar={false}
              style={styles.pdf}
            >
              <PdfDocument invoicedata={InvoiceData} data={data} />
            </PDFViewer>
            <div className="w-full flex justify-end">
              <button className="bg-[#14AE5C] text-white rounded-lg mt-4">
                <PDFDownloadLink
                  document={<PdfDocument invoicedata={InvoiceData} />}
                  fileName={"POSP_Certificate.pdf"}
                  className="hover:text-white"
                >
                  {({ blob, url, loading, error }) =>
                    loading ? "Loading..." : "Download POSP Certificate"
                  }
                </PDFDownloadLink>
              </button>
            </div>
          </div>
        ) : data?.certificateStatus === "pending" ? (
          <div className="flex justify-center items-center">
            <div className="p-8 bg-white rounded-lg shadow-lg flex flex-col items-center gap-4">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-[80px] h-[80px] text-orange-500"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                  />
                </svg>
              </div>
              <p className="text-center text-orange-500 font-semibold text-lg">
                The certificate is currently pending approval by the
                <br />
                administration. Please check back at a later time.
              </p>
            </div>
          </div>
        ) : data?.certificateStatus === "rejected" ? (
          <div className="flex justify-center items-center">
            <div className="p-8 bg-white rounded-lg shadow-lg flex flex-col items-center gap-4">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-[80px] h-[80px] text-red-500 border-2 border-red-500 rounded-full"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18 18 6M6 6l12 12"
                  />
                </svg>
              </div>
              <p className="text-center text-red-500 font-semibold text-lg">
                The certificate has been rejected by the administration.
                <br />
                Please review the details.
              </p>
            </div>
          </div>
        ) : (
          <div className="m-auto mt-20 text-3xl">Network error</div>
        )
      ) : (
        <div className="m-auto mt-5 w-[40%]">
          <div className="flex justify-center items-center absolute inset-0">
            <div className="animate-spin rounded-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-16 h-16"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                />
              </svg>
            </div>
          </div>
        </div>
      )}
      {/* 
      <div className='download-link ' style={styles.download}>
        <PDFDownloadLink
          document={<PdfDocument invoicedata={InvoiceData} />}
          fileName={fileName}
        >
          {({ blob, url, loading, error }) =>
            loading ? "Loading..." : "Download POSP Certificate"
          }
        

        </PDFDownloadLink>
      </div> */}
    </div>
  );
};

export default Tables;
